/**
 * Hook to fetch and manage hospital name from group data
 */

import { useCallback, useEffect, useRef, useState } from "react";

import { getHospitalName } from "../group";

export const useHospitalName = (groupId?: string) => {
  const [hospitalName, setHospitalName] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const ignoreRef = useRef(false);

  const fetchHospitalName = useCallback(async (id: string) => {
    ignoreRef.current = false;
    setLoading(true);
    try {
      const name = await getHospitalName(id);
      if (!ignoreRef.current) {
        setHospitalName(name);
      }
    } catch {
      if (!ignoreRef.current) {
        setHospitalName(null);
      }
    } finally {
      if (!ignoreRef.current) {
        setLoading(false);
      }
    }
  }, []);

  const refetch = useCallback(() => {
    if (groupId) {
      return fetchHospitalName(groupId);
    }
  }, [groupId, fetchHospitalName]);

  useEffect(() => {
    if (groupId) {
      fetchHospitalName(groupId);
    } else {
      setHospitalName(null);
      setLoading(false);
    }

    return () => {
      ignoreRef.current = true;
    };
  }, [groupId, fetchHospitalName]);

  return { hospitalName, loading, refetch };
};
